import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DrawRoundedIcon from "@mui/icons-material/DrawRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { blue, red, green } from "@mui/material/colors";
import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";

export const handleCheckListStatus = (doc) => {
    if (doc.docCount > 0) {
        if (doc.categoryName === "Esito Pratiche") {
            return (
                <Tooltip title={t("Optional")}>
                    <RemoveRoundedIcon style={{ color: blue[500] }} />
                </Tooltip>
            );
        } else {
            return (
                <Tooltip title={t("Complete")}>
                    <DoneRoundedIcon style={{ color: green[500] }} />
                </Tooltip>
            );
        }
    }
    if (doc.docCount === 0) {
        return (
            <Tooltip title={t("Incomplete")}>
                <CloseRoundedIcon style={{ color: red[500] }} />
            </Tooltip>
        );
    }

};

export const handleStatusSign = (status) => {
    let color = "";
    let text = "";
    if (status === "in attesa") {
        color = "#D86F07";
        text = "In Attesa";
    }
    if (status === "firmato") {
        color = "#359F1C";
        text = "Firmato";
    }
    if (status === "da firmare") {
        color = "#C1272D";
        text = "Da Firmare";
    }

    return (
        <p className="font-bold" style={{ color: `${color}` }}>
            {text}
        </p>
    );
};

export const handleCheckSignStatus = (status) => {

    if (status === "firmato") {
        return (
            <Tooltip title={t("Visualize")}>
                <IconButton
                    // onClick={() => onNavigate(documento.categoryId)}
                    className="w-10 h-10"
                >
                    <SearchRoundedIcon />
                </IconButton>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip title={t("Firma")}>
                <IconButton
                    // onClick={() => onNavigate(documento.categoryId)}
                    className="w-10 h-10"
                >
                    <DrawRoundedIcon />
                </IconButton>
            </Tooltip>
        );
    }

};